import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';
import type { MergedState } from 'src/app/shared/hooks/state';

import { prefetchBusinessPageDataFromApi, useBusinessPageDataFromApi } from './pageData';

export type BusinessPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useBusinessPageDataFromApi>[0]>;
}>;

export type BusinessPageCombinedState = MergedState<ReturnType<typeof useBusinessPageDataFromApi>>;

export function usePageContext(prefetchedData?: BusinessPagePrefetchedContext): BusinessPageCombinedState {
	const l10n = {
		countryCode: useCountryCode(),
		locale: useLocale(),
	};
	return useBusinessPageDataFromApi(prefetchedData?.pageData, l10n);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<BusinessPagePrefetchedContext> {
	return { pageData: await prefetchBusinessPageDataFromApi(context, context.l10n) };
}

export type BusinessPagePrefetchedDataProps = PrefetchedDataProps<BusinessPagePrefetchedContext>;
